import React, { useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import RouterSuspense from '~/app/common/RouterSuspense';
import Notifications from '.';
import { useStoreState } from '~/store';
import { ROUTES } from '~/app/Router';

export const REQUESTS_ROUTES = {
    notifications: '/notifications',
    chat: '/notifications/chat',
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => {
    const history = useHistory();
    const netWorkStatus = useStoreState(state => state.app.offline.status);

    useEffect(() => {
        if (netWorkStatus !== 0) {
            history.push(ROUTES.projects);
        }
    }, [netWorkStatus, history]);

    if (netWorkStatus !== 0) {
        return null;
    }

    return (
        <RouterSuspense>
            <Switch>
                <Route path={REQUESTS_ROUTES.chat} component={Notifications}/>
                <Route exact path={REQUESTS_ROUTES.notifications} component={Notifications}/>
            </Switch>
        </RouterSuspense>
    );
};

export default Router;
